import { render } from "./instructor-assignment.vue?vue&type=template&id=ddbb8808"
import script from "./instructor-assignment.vue?vue&type=script&lang=js"
export * from "./instructor-assignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__